import { Injectable } from '@angular/core';

@Injectable()
export class APIs_Config {
    site_id = 1;
    cfg = {

        get_location: {
            env: 'SIGN_UP',
            path: 'dpw5000/500001',
            format: {
                "product_id": this.site_id,
            },
            required: true
        },
        get_images1: {
            env: 'SIGN_UP',
            path: 'dpw5000/500002',
            format: {
                "product_id": this.site_id,
            },
            required: true
        },
        get_images2: {
            env: 'SIGN_UP',
            path: 'dpw5000/500003',
            format: {
                "product_id": this.site_id,
            },
            required: true
        },
        getAllPropListing: {
            env: 'GET_ALL_PROP_LISTING',
            path: 'dpw5002/500006',
            format: {
                "product_id": this.site_id,
            },
            required: true
        },
        getSearchProduct: {
            env: 'GET_SEARCH_PROPERTY',
            path: 'dpw5001/500004',
            format: {
                "location_id": "",
                "property_type": 0,
            },
            required: true
        },
        contact_mail: {
            env: "CONTACT_MAIL",
            path: 'dpw5003/500007',
            format: {
                "name": "",
                "email": "",
                "mobile": 0,
                "city": "",
                "state": "",
                "country": "",
                "message": "",
                "bedroom": 0,
                "budget": 0.
            }
        },
        prop_desc: {
            env: "PROP_DESC",
            path: 'dpw5001/500005',
            format: {
                'property_id': 0,
            }
        },
        get_currency_list: {
            env: "CURRENCY_LIST",
            path: 'dpw5000/500009',
            format: {
                "product_id": this.site_id,
            }
        }
    }
}